import AxiosHttpClient, { IHttpClient } from './axios'
import { Action, ContentType } from '@/common/constant'
import { handleNetworkError } from '@/common/common-fn'
import { getAuthToken } from '@/utils/auth'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

export default class BaseHttpClient extends AxiosHttpClient {
  // #region Property

  controller: string | undefined
  entityName: string | undefined

  // #endregion

  // #region Constructor
  constructor (controller?: string | undefined, entityName?: string | undefined, baseUrl?: string, timeOut?: number | undefined) {
    super(baseUrl, timeOut)

    const me = this

    me.controller = controller
    me.entityName = entityName

    me.setRequestInterceptor(me.beforeSendRequest, me.onError)
    me.setResponseInterceptor(me.beforeReturnResponse, me.onError)

    if (controller && entityName) { // VD entityName = Student
      // Đọc
      // ! Nếu truyền id => GetOne, không truyền id => GetMany
      const getFnName = `${Action.GET}${me.entityName}` // * Format: get{entityName} - getStudent
      Object.assign(this, {
        [getFnName]: (
          id: any
        ) => {
          return me.getAsync(id ? `${id}` : '')
        }
      })

      // Thêm
      const addFnName = `${Action.ADD}${me.entityName}` // * Format: add{entityName} - addStudent
      Object.assign(this, {
        [addFnName]: (
          payload: any
        ) => {
          return me.postAsync('', payload)
        }
      })

      // Cập nhật
      const updateFnName = `${Action.UPDATE}${me.entityName}` // * Format: update{entityName} - updateStudent
      Object.assign(this, {
        [updateFnName]: (
          id: any,
          payload: any
        ) => {
          return me.putAsync(`${id}`, payload)
        }
      })

      // Xóa
      const deleteFnName = `${Action.DELETE}${me.entityName}` // * Format: delete{entityName} - deleteStudent
      Object.assign(this, {
        [deleteFnName]: (
          id: any
        ) => {
          return me.deleteAsync(`${id}`)
        }
      })

      // Deprecated
      const deleteMultiFnName = `${Action.DELETE}${me.entityName}s`
      Object.assign(this, {
        [deleteMultiFnName]: (
          listOfId: any[]
        ) => {
          return me.deleteAsync('list', { data: listOfId })
        }
      })
    }
  }

  // #endregion

  // #region Method

  /**
   * @description Default config của axios
   * @return
   * @author PHNam
   */
  getDefaultConfigs (): AxiosRequestConfig {
    const me = this
    const baseURL = me.getBaseUrl()
    const configs: Record<string, any> = {
      contentType: ContentType.ApplicationJsonUTF8,
      transformRequest: [me.processData, me.processHeader],
      transformResponse: [me.transformDate]
    }

    if (baseURL) {
      configs.baseURL = baseURL
    }

    return configs
  }

  /**
   * @description
   * @returns
   * @author PHNam
   */
  getBaseUrl (): string | undefined {
    const me = this
    let baseURL = me.baseURL

    if (!baseURL) { return }
    const separate = baseURL.endsWith('/') ? '' : '/'

    if (me.controller && baseURL) {
      baseURL = `${me.baseURL}${separate}${me.controller}`
    }

    return baseURL
  }

  /**
   * @description Xử lý dữ liệu trước khi gửi request
   * @param {*} data
   * @param {*} headers
   * @returns
   * @author PHNam
   */
  processData (data: any, headers: any) {
    return data
  }

  /**
   * @description Xử lý header trước khi gửi request
   * @param {*} data
   * @param {*} headers
   * @returns
   * @author PHNam
   */
  processHeader (data: any, headers: any) {
    const token = getAuthToken()

    if (token) {
      headers.common.Authorization = token ? `Bearer ${token}` : ''
    }

    return data
  }

  /**
   * @description Xử lý json parse date
   * @param {*} response
   * @returns
   * @author PHNam
   */
  transformDate (response: string) {
    if (!response) return
    // Do whatever you want to transform the data
    const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|(\+|-)([\d|:]*))?$/
    // const reMsAjax = /^\/Date\((d|-|.*)\)[/|\\]$/

    const dateParser = function (key: string, value: any) {
      if (typeof value === 'string') {
        const dateStr = reISO.exec(value)

        if (dateStr) {
          return new Date(value)
        }

        // a = reMsAjax.exec(value)
        // if (a) {
        //   const b = a[1].split(/[-+,.]/)
        //   return new Date(b[0] ? +b[0] : 0 - +b[1])
        // }
      }
      return value
    }

    return JSON.parse(response, dateParser)
  }

  /**
   * @description Xử lý trước khi gửi request đi, VD như add token
   * @param {Object} config
   * @author PHNam
   */
  beforeSendRequest (config: AxiosRequestConfig) {
    return config
  }

  /**
   * @description Xử lý trước khi trả về response, VD như chỉ trả về data
   * @param {@} response
   * @author PHNam
   */
  beforeReturnResponse (response: AxiosResponse<any>) {
    // if (response.data.Code !== HttpStatusCode.OK) {
    //   handleNetworkError(response.data)
    // }

    return response.data
  }

  /**
   * @description
   * @param {*} error
   * @returns
   */
  onError (error: any) {
    // handleNetworkError(error)

    return Promise.reject(error)
  }

  // #endregion
}

const httpClient = new BaseHttpClient()
export { httpClient }
